import LazyHelper from '../helpers/lazy-helper';

const InitHubs = {
    init: function () {
        document.addEventListener("DOMContentLoaded", function () {
            let isEventListenerAttached = false;
            if (getScrollFromTopValue() <= 0) {
                loadHubs();
            }
            else {
                isEventListenerAttached = true;
                window.addEventListener('scroll', loadHubs);
                let timeout = setInterval(() => {
                    if (getScrollFromTopValue() <= 0) {
                        clearInterval(timeout);
                        loadHubs();
                        const event = new Event('lazy-load');
                        window.dispatchEvent(event);
                    }
                }, 300);
            }

            function loadHubs() {
                if (getScrollFromTopValue() <= 0) {
                    {
                        if (isEventListenerAttached) {
                            window.removeEventListener('scroll', loadHubs);
                        }

                        let jqueryScriptUrl = '/Scripts/libs/jquery.min.js';
                        if ('undefined' == typeof window.jQuery) {
                            if (!LazyHelper.doesScriptExists(jqueryScriptUrl)) {
                                LazyHelper.addScriptFile(jqueryScriptUrl, 'jquery', true);
                            }
                        }

                        LazyHelper.waitJqueryToLoad(function () {
                            loadHubsScript();
                        });
                    }
                };
            }

            function loadHubsScript() {
                if (!document.getElementById('hubs-script')) {
                    let ev1 = LazyHelper.addScriptFile('/Frontend-Assembly/SitefinityWebApp/Mvc/Scripts/ResultWidget/hubs.js', 'hubs-script', false);
                    ev1.onload = function () {
                        var data = document.getElementsByClassName('js-load-hubs')[0];

                        loadHubsKendoComponenets(
                            data.getAttribute('data-numberOfItems'),
                            data.getAttribute('data-strGuid'),
                            data.getAttribute('data-kendoCore'),
                            data.getAttribute('data-serviceUrl'),
                            data.getAttribute('data-initialNumberOfItems'),
                            data.getAttribute('data-culture'),
                            data.getAttribute('data-elasticSearchIndexName'),
                            data.getAttribute('data-conditionalDetailsPageUrlsToJson'),
                            true
                        );
                    }
                }
            }

            function getScrollFromTopValue() {
                let hubs = document.getElementsByClassName('js-load-hubs');
                if (hubs.length > 0) {
                    return hubs[0].getBoundingClientRect().top - 1400;
                }

                return 1;
            };
        });
    }
}

InitHubs.init();